export const LOCKOUT_MODAL_TIMEOUT = 15000;
export const MAX_LOGGED_OUT_WATCH_SECONDS = 15;
export const TRANSCRIPT_LOCKOUT_MODAL_LOCAL_STORAGE_KEY = 'transcriptModalSeen';
export const ANSWERS_LOCKOUT_MODAL_LOCAL_STORAGE_KEY = 'answers.visited';

export enum LockoutModalVariant {
  /** Standard signed-out prompt: "Start learning instantly — free for 7 days" */
  DEFAULT = 'default',
  /** Quiz context: "Keep going with your quiz after sign up — free for 7 days" */
  QUIZ = 'quiz',
  /** Expired prime account: shows expiry notice and "View plans" CTA */
  EXPIRED_PRIME = 'expired_prime',

  /**
   * Standard signed-out AI prompt: "Learn side by side about any medical topic with Osmosis AI.
   */
  DEFAULT_AI = 'default_ai',
  /** Expired prime account AI prompt: "Continue your conversation." */
  EXPIRED_PRIME_AI = 'expired_prime_ai',
}
